export function cleanupHelmSymbol(symbol) {
    if (symbol.startsWith('[') && symbol.endsWith(']'))
        return symbol.slice(1, -1);
    return symbol;
}
//# sourceMappingURL=utils.js.map